/* eslint-disable import/no-unresolved, no-restricted-syntax */
import Tooltip from 'bootstrap/js/dist/tooltip';

(() => {
  // Désactivation simple en mode admin
  if (window.location.pathname.includes('/admin')) {
    return;
  }

  const tooltipTriggerList = document.querySelectorAll(
    '[data-bs-toggle="tooltip"]',
  );
  const tooltipList = [...tooltipTriggerList].map(
    (tooltipTriggerEl) => new Tooltip(tooltipTriggerEl),
  );
})();
